import React from "react";
import {PageLayout} from "../../components/layout/Page/PageLayout.jsx";
import {GridContainerFlex} from "../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {RequestPasswordResetForm} from "./components/RequestPasswordResetForm.jsx";

export const RequestPasswordReset = (props) => {

    return (
        <PageLayout>
            <GridContainerFlex alignItems={"center"} justifyContent={"center"} style={{height: "100vh"}}>
                <GridItemFlex xs={12} sm={6} md={3}>
                    <RequestPasswordResetForm />
                </GridItemFlex>
            </GridContainerFlex>
        </PageLayout>
    )
}